import ultimateLightboxExtension from "./ultimate-lightbox-extension";

const ultimateLightboxQuiz = () => {
    var selector_array = ewd_ulb_php_add_data.image_selector_list.split(',');
    var title_src = ewd_ulb_php_add_data.overlay_text_source == 'caption' ? 'title' : 'alt';
    var description_src = ewd_ulb_php_add_data.overlay_text_source == 'caption' ? 'caption' : 'alt';

    jQuery(selector_array).each(function(index, el) {
        jQuery(el).each(function() {
            if (jQuery(this).height() >= ewd_ulb_php_add_data.min_height && jQuery(this).width() >= ewd_ulb_php_add_data.min_width) {

                if (description_src == 'caption') {var description = jQuery(this).closest('figure').find('figcaption').html();}
                else {var description = jQuery(this).attr(description_src);}

                jQuery(this).parent().addClass('ewd-ulb-lightbox');
                jQuery(this).parent().data('ulbsource', jQuery(this).attr('src'));
                jQuery(this).parent().data('ulbtitle', jQuery(this).attr(title_src));
                jQuery(this).parent().data('ulbdescription', description);
            }
        });
    });

    ultimateLightboxExtension('.question-content .ewd-ulb-lightbox')
}

export default ultimateLightboxQuiz